import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Interface } from "ethers";
import { useWalletConnection } from "../../utility/useWalletConnection";
import { useDispatch } from "react-redux";
import { useData } from "../../utility/useData";
import Header from "../../components/header/Header";
import LeftMenu from "../../components/left-menu/LeftMenu";
import CesiumMap from "../../components/cesium-map/CesiumMap";
import Stake from "../../components/stake/Stake";
import PageLoading from "../../components/popups/PageLoading";
import ToastMessage from "../../components/toast-message/ToastMessage";
import { getInfo, getTickets } from "./store";
//images
import Mobile from "../../assets/img/mobile2.jpg";
import Globe from "../../assets/img/globe.png";
import ClickMenuPng from "../../assets/img/clickmenu.png";

const Home = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const dispatch = useDispatch();

  const {
    isConnected,
    connectedWalletInfo,
    address,
    chainId,
    signerVars,
    unSignerVars,
    mockVRF,
    errorMessage,
    clearError,
    open,
    connect,
    disConnect,
  } = useWalletConnection();

  const {
    decimals,
    initialResultMsg,
    initialData,
    reRender,
    poolData,
    showPoolDetail,
    toastArgs,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
    setToastArgs,
    getToken,
  } = useData();

  const [pageLoading, setPageLoading] = useState(false);
  const [pageLoadingMsg, setPageLoadingMsg] = useState(null);

  const [poolCount, setPoolCount] = useState(null);
  const [pools, setPools] = useState([]);

  const sideBarStatus = sessionStorage.getItem("sidebar");
  const [sideBar, setSideBar] = useState(
    sideBarStatus ? JSON.parse(sideBarStatus) : true
  );
  const [cesiumWith, setCesiumWith] = useState(!sideBar ? "100%" : "120%");
  const cesiumMapRef = useRef(null);

  const handleFlyToCity = async (flyToPoolData) => {
    if (flyToPoolData.poolId === 0) {
      closeData();
      cesiumMapRef.current.flyToCity(
        Number(flyToPoolData.lat),
        Number(flyToPoolData.long),
        Number(flyToPoolData.zoom),
        Number(flyToPoolData.distance)
      );
    } else {
      setPageLoadingMsg(`Loading pool details`);
      setPageLoading(true);

      closeData();

      cesiumMapRef.current.flyToCity(
        Number(flyToPoolData.lat),
        Number(flyToPoolData.long),
        Number(flyToPoolData.zoom),
        Number(flyToPoolData.distance)
      );

      const maxTicketCount = Number(
        (
          await unSignerVars.contract.getInfo(
            flyToPoolData.poolId,
            address || "0x0000000000000000000000000000000000000000"
          )
        ).maxTicketCount
      );
      const lockTokenAddress = await unSignerVars.contract.lockToken(
        flyToPoolData.poolId
      );
      const prizeTokenAddress = await unSignerVars.contract.prizeToken(
        flyToPoolData.poolId
      );
      const totalPrizeToken = await unSignerVars.contract.totalPrizeToken(
        flyToPoolData.poolId
      );
      const poolTicketLimit = Number(
        await unSignerVars.contract.poolTicketLimit(flyToPoolData.poolId)
      );
      const lockToken = await getToken(
        signerVars,
        unSignerVars,
        lockTokenAddress
      ).catch((error) => {
        console.log(`(lockToken) ${error.reason || error.message}`);
      });
      const prizeToken = await getToken(
        signerVars,
        unSignerVars,
        prizeTokenAddress
      ).catch((error) => {
        console.log(`(prizeToken) ${error.reason || error.message}`);
      });

      flyToPoolData.status = Number(
        await unSignerVars.contract.getStatus(flyToPoolData.poolId)
      );

      //TODO: merge işlemi stake dosyasına taşınacak
      const mergeFlyToPoolData = {
        ...flyToPoolData,
        maxTicketCount,
        lockTokenAddress,
        prizeTokenAddress,
        lockTokenSymbol: lockToken && lockToken.symbol,
        prizeTokenSymbol: prizeToken && prizeToken.symbol,
        lockTokenDecimals: lockToken && lockToken.decimals,
        prizeTokenDecimals: prizeToken && prizeToken.decimals,
        totalPrizeToken,
        poolTicketLimit,
      };

      updatePoolData(mergeFlyToPoolData);
      let duration = Number(flyToPoolData.zoom) * 100;

      setTimeout(() => {
        openData();
      }, duration);

      console.log("fly to pool:", mergeFlyToPoolData);
      setPageLoadingMsg(null);
      setPageLoading(false);
    }
  };

  const toggleSideBar = () => {
    setSideBar((prevState) => !prevState);
    sessionStorage.setItem("sidebar", !sideBar);
    if (sideBar) {
      setCesiumWith("100%");
    } else {
      setCesiumWith("120%");
    }
  };

  const getPoolCount = async () => {
    const poolCounter = Number(await unSignerVars.contract.poolCounter());
    console.log(">> Pool Count:", poolCounter);
    setPoolCount(poolCounter);
  };

  const getPools = async () => {
    //TODO: poollar sayfalanacak
    // const poolsCache = JSON.parse(sessionStorage.getItem("pools"));
    // console.log("poolsCache:", poolsCache);

    // if (poolsCache && poolsCache.length === poolCount) {
    //   setPools(poolsCache);
    // } else {
    let _pools = [];
    const callbackMaxTicket = Number(
      await unSignerVars.contract.callbackMaxTicket()
    );

    for (let poolId = 1; poolId <= poolCount; poolId++) {
      const pool = await unSignerVars.contract.pools(poolId);
      const poolStatus = Number(await unSignerVars.contract.getStatus(poolId));

      const poolObj = {
        poolId,
        name: pool.name,
        createDate: Number(pool.createDate),
        joinDay: Number(pool.joinDay),
        lockDay: Number(pool.lockDay),
        totalPool: pool.totalPool,
        oneTicketOfToken: pool.oneTicketOfToken,
        minTicketCount: 1,
        status: poolStatus,
        lat: pool.lat,
        long: pool.long,
        zoom: 2,
        distance: 500000,
        callbackMaxTicket,
      };
      _pools.push(poolObj);
    }

    _pools.reverse(function (a, b) {
      return a.poolId - b.poolId;
    });

    console.log(">> Pools:", _pools);
    console.log(_pools);
    setPools(_pools);

    //   sessionStorage.setItem(
    //     "pools",
    //     JSON.stringify(_pools, (key, value) =>
    //       typeof value === "bigint" ? value.toString() : value
    //     )
    //   );
    // }
  };

  useEffect(() => {
    try {
      if (unSignerVars.contract) {
        getPoolCount();

        if (poolCount > 0) {
          getPools();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [unSignerVars.contract, poolCount]);

  useEffect(() => {
    if (signerVars && signerVars.isOwner) {
      navigate("/panel");
    }
    closeData();
  }, [signerVars]);

  //Event listeners (wss)
  // useEffect(() => {
  //   if (!unSignerVars.socketProvider) return;
  //   if (!unSignerVars.socketSubId) return;
  //   if (!address) return;

  //   const listenerPoolCreated = async (poolId) => {
  //     console.log("#PoolCreated (home) event was emmited");
  //     if (pools.length !== Number(poolId)) {
  //       sessionStorage.removeItem(pools);
  //       await getPoolCount();
  //       console.log(">> Event: Updated pools");
  //     }
  //   };

  //   const listenerRequestFulfilled = async (
  //     requestId,
  //     reqType,
  //     poolId,
  //     user,
  //     numberOfWords
  //   ) => {
  //     console.log("#RequestFulfilled (home) event was emmited");
  //     if (
  //       Number(reqType) === 1 &&
  //       address?.toLowerCase() === user.toLowerCase()
  //     ) {
  //       const info = await dispatch(
  //         getInfo({ dispatch, unSignerVars, poolId: Number(poolId), address })
  //       )
  //         .then((result) => {
  //           if (result.payload.result) {
  //             return result.payload.result;
  //           }
  //         })
  //         .catch((error) => console.error(error));

  //       const prizeTokenAddress = await unSignerVars.contract.prizeToken(
  //         poolId
  //       );
  //       const prizeToken = await getToken(
  //         signerVars,
  //         unSignerVars,
  //         prizeTokenAddress
  //       );
  //       dispatch(
  //         getTickets({
  //           dispatch,
  //           unSignerVars,
  //           poolId: Number(poolId),
  //           address: user,
  //           userTicketCount: info.userTicketCount,
  //           decimals: prizeToken.decimals,
  //         })
  //       )
  //         .then((result) => {
  //           if (result.payload.result) {
  //             setToastArgs({
  //               header: "VRF Confirmation",
  //               messageType: 1,
  //               message: "Ticket purchase process completed.",
  //               isShow: true,
  //             });
  //           }
  //         })
  //         .catch((error) => console.error(error));
  //     }
  //   };

  //   unSignerVars.socketProvider.websocket.onmessage = async (event) => {
  //     const data = JSON.parse(event.data);
  //     if (
  //       data.method === "eth_subscription" &&
  //       data.params.subscription === unSignerVars.socketSubId
  //     ) {
  //       if (
  //         data.params.result.topics.includes(
  //           "0x65fc0eb45954044fb55e1b01344d5d72fbfdf88e732d955f73bb7fb2bcc131e9"
  //         )
  //       ) {
  //         const iface = new Interface(unSignerVars.ticketAbi.abi);
  //         const eventPoolCreated = iface.parseLog({
  //           data: data.params.result.data,
  //           topics: data.params.result.topics,
  //         });
  //         console.log(">>", eventPoolCreated);
  //         listenerPoolCreated(eventPoolCreated.args.gameId);
  //       }

  //       if (
  //         data.params.result.topics.includes(
  //           "0x55a8e9addee03ab17f9707c6fe7aa2b5bdc9e3728e0727ff7e67931522efe7d7"
  //         )
  //       ) {
  //         const iface = new Interface(unSignerVars.ticketAbi.abi);
  //         const eventRequestFulfilled = iface.parseLog({
  //           data: data.params.result.data,
  //           topics: data.params.result.topics,
  //         });
  //         console.log(">>", eventRequestFulfilled);
  //         if (address) {
  //           listenerRequestFulfilled(
  //             eventRequestFulfilled.args.requestId,
  //             eventRequestFulfilled.args.reqType,
  //             eventRequestFulfilled.args.poolId,
  //             eventRequestFulfilled.args.user,
  //             eventRequestFulfilled.args.numberOfWords
  //           );
  //         }
  //       }
  //     }
  //   };

  //   unSignerVars.socketProvider.websocket.onerror = (error) => {
  //     console.error("WebSocket error:", error);
  //   };

  //   unSignerVars.socketProvider.websocket.onclose = () => {
  //     console.log("WebSocket connection closed");
  //   };

  //   return async () => {
  //     const subId = unSignerVars.socketSubId;
  //     await unSignerVars.socketProvider.send("eth_unsubscribe", [subId]);
  //   };
  // }, [unSignerVars.socketProvider, unSignerVars.socketSubId, address]);

  //Event listeners (https)
  useEffect(() => {
    if (!unSignerVars.contract) return;
    if (!address) return;

    const listenerDebugLogger = async (event) => {
      console.log("DebugLogger:", event);
    };
    const listenerErrorLogger = async (event) => {
      console.log("ErrorLogger:", event);
    };

    const listenerPoolCreated = async (poolId, poolAdmin, event) => {
      console.log("#PoolCreated (home) event was emmited");
      console.log("eLog:", event.log);

      if (pools.length !== Number(poolId)) {
        sessionStorage.removeItem(pools);
        await getPoolCount();
        console.log(">> Event: Updated pools");
      }
    };

    const listenerRequestFulfilled = async (
      requestId,
      reqType,
      poolId,
      user,
      numberOfWords,
      event
    ) => {
      console.log("#RequestFulfilled (home) event was emmited");
      console.log("eLog:", event.log);
      
      if (
        Number(reqType) === 1 &&
        address?.toLowerCase() === user.toLowerCase()
      ) {
        const info = await dispatch(
          getInfo({ dispatch, unSignerVars, poolId: Number(poolId), address })
        )
          .then((result) => {
            if (result.payload.result) {
              return result.payload.result;
            }
          })
          .catch((error) => console.error(error));

        const prizeTokenAddress = await unSignerVars.contract.prizeToken(
          poolId
        );
        const prizeToken = await getToken(
          signerVars,
          unSignerVars,
          prizeTokenAddress
        );
        dispatch(
          getTickets({
            dispatch,
            unSignerVars,
            poolId: Number(poolId),
            address: user,
            userTicketCount: info.userTicketCount,
            decimals: prizeToken.decimals,
          })
        )
          .then((result) => {
            if (result.payload.result) {
              setToastArgs({
                header: "VRF Confirmation",
                messageType: 1,
                message: "Ticket purchase process completed.",
                isShow: true,
              });
            }
          })
          .catch((error) => console.error(error));
      }
    };

    unSignerVars.contract?.on("PoolCreated", listenerPoolCreated);
    unSignerVars.contract?.on("RequestFulfilled", listenerRequestFulfilled);
    // unSignerVars.provider.on("debug", listenerDebugLogger);
    unSignerVars.provider.on("error", listenerErrorLogger);
    console.log("+>>> On useEffect (home event listeners)");
    return () => {
      unSignerVars.contract?.off("PoolCreated", listenerPoolCreated);
      unSignerVars.contract?.off("RequestFulfilled", listenerRequestFulfilled);
      console.log("->>> returned useEffect (home event listeners)");
    };
  }, [unSignerVars.contract, address]);

  return (
    <>
      <ToastMessage />
      {pageLoading && <PageLoading pageLoadingMsg={pageLoadingMsg} />}
      <div className="pop">
        <img src={Mobile} alt="" />
      </div>
      <div className="vestbody">
        <Header />
        <div className="content-wrapper">
          {!sideBar && (
            <div
              className="mobile-sidebar-toggle"
              onClick={() => toggleSideBar()}
            >
              <span>
                Click the world for <br /> Staking Pools
              </span>
              <img className="w-auto" src={ClickMenuPng} alt="" />
            </div>
          )}
          <img
            className={sideBar ? "globe showglobe" : "globe hideglobe"}
            src={Globe}
            onClick={() => handleFlyToCity(initialData)}
            alt=""
          />
          <Link
            href={search}
            className={
              sideBar
                ? "arr-right-link hidesarrow"
                : "arr-right-link showsarrow"
            }
            title={sideBar ? "Hide Sidebar" : "Show Sidebar"}
            onClick={() => toggleSideBar()}
          />
          <div className={"right-map-area "}>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n     #toolbar {\n       position: absolute;\n       top:0;\n     }\n     ",
              }}
            />
            <div id="cesiumContainer" className="fullSize" />
            <div id="loadingOverlay">
              {showPoolDetail && <Stake handleFlyToCity={handleFlyToCity} />}
              <CesiumMap
                cesiumWith={cesiumWith}
                className={"csmp"}
                ref={cesiumMapRef}
                myLat={initialData.lat}
                myLng={initialData.long}
                defDistance={initialData.distance}
                handleFlyToCity={handleFlyToCity}
                poolCount={poolCount}
                pools={pools}
              />
            </div>
          </div>
          <div
            className={
              sideBar ? "left-menu-area shows" : "left-menu-area hides"
            }
          >
            <Link
              to={search}
              className="arr-right-link"
              onClick={() => toggleSideBar()}
            />
            <LeftMenu
              myLat={initialData.lat}
              myLng={initialData.long}
              defDistance={initialData.distance}
              handleFlyToCity={handleFlyToCity}
              poolCount={poolCount}
              pools={pools}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
